import { useEffect } from "react";
import type { Map as MapLibreMap } from "maplibre-gl";

const SOURCE = "tactical-plugin-range-ring";
const FILL = "tactical-plugin-range-ring-fill";
const LINE = "tactical-plugin-range-ring-line";

type Props = {
  map: MapLibreMap | null;
  feature: GeoJSON.Feature<GeoJSON.Polygon> | null;
};

export function TacticalRangeRingOverlay({ map, feature }: Props) {
  useEffect(() => {
    if (!map) return;
    const data: GeoJSON.FeatureCollection = {
      type: "FeatureCollection",
      features: feature ? [feature] : [],
    };
    const ensure = () => {
      if (!map.getSource(SOURCE)) {
        map.addSource(SOURCE, { type: "geojson", data });
      }
      if (!map.getLayer(FILL)) {
        map.addLayer({
          id: FILL,
          type: "fill",
          source: SOURCE,
          paint: { "fill-color": "#2563eb", "fill-opacity": 0.12 },
        });
      }
      if (!map.getLayer(LINE)) {
        map.addLayer({
          id: LINE,
          type: "line",
          source: SOURCE,
          paint: { "line-color": "#2563eb", "line-width": 2 },
        });
      }
    };
    const sync = () => {
      try {
        ensure();
        const src = map.getSource(SOURCE) as
          | { setData: (d: GeoJSON.FeatureCollection) => void }
          | undefined;
        src?.setData(data);
      } catch {
        /* style */
      }
    };
    if (map.isStyleLoaded()) sync();
    else map.once("load", sync);
    map.on("styledata", sync);
    sync();
    return () => {
      map.off("styledata", sync);
      try {
        if (map.getLayer(LINE)) map.removeLayer(LINE);
        if (map.getLayer(FILL)) map.removeLayer(FILL);
        if (map.getSource(SOURCE)) map.removeSource(SOURCE);
      } catch {
        /* disposed */
      }
    };
  }, [map, feature]);

  return null;
}
